module.exports = __webpack_public_path__ + "img/brand-13.f75f9680.png";